import { Group, Stack, Text } from '@mantine/core';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, IdentifierLinks, JournalLink, LanguagePill, PublisherLink, WosIndexList } from '@feature/utils';

import { CitationProofAction } from './Proof';
import { CitationDeleteButton } from './components/CitationDeleteButton';
import { Citation } from './model/CitationTypes';

interface CitationViewProps {
  citation: Citation;
  publicationId: number;
}

export function CitationView({ citation, publicationId }: CitationViewProps) {
  const { title, identifiers, noOfAuthors, journal, publisher, authors, wosIndexes } = citation;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="xs">
          <Group justify="space-between">
            <Group>
              <Text
                fw={500}
                size="lg"
              >
                {title}
              </Text>
            </Group>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <CitationDeleteButton
                citationId={citation.id}
                publicationId={publicationId}
              />
            </Group>
          </Group>
          <Group>
            <Text>{journal?.language && <LanguagePill language={journal.language} />}</Text>
            <Text>{noOfAuthors} autori</Text>
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <Stack gap="xs">
          {publisher && (
            <PublisherLink
              publisherId={publisher.id}
              title={publisher.title}
            />
          )}
          {journal && (
            <JournalLink
              journalId={journal.id}
              title={journal.title}
            />
          )}
        </Stack>
      </Content>
      <Content type="full">
        <Stack>
          <IdentifierLinks identifiers={identifiers} />
        </Stack>
      </Content>
      <Content type="full">
        <WosIndexList indexes={wosIndexes} />
      </Content>
      {authors.length > 0 && (
        <Content type="full">
          <AuthorList authors={authors} />
        </Content>
      )}
      <CitationProofAction
        citationId={citation.id}
        authors={authors}
      />
    </Stack>
  );
}
